export function parseClipSlug(slug) {
  if (!slug.startsWith("C-")) throw new Error("Invalid slug");

  const rest = slug.slice(2); // saco el "C-"
  const [senderId, clipId, templateId] = rest.split("__");

  return { senderId, clipId, templateId };
}
